import { SearchCodeRequest, SearchCodeResult } from "@t3/shared";
import { createHttpsCallableHook } from "./createHttpsCallableHook";

const middlewareOnCallSearchCodeRequest = (request: SearchCodeRequest) => {
  const updatedRequest = {
    ...request,
    code: request.code.toUpperCase().trim(),
  };

  if (!updatedRequest.code) {
    throw new Error("Code is required");
  }

  return updatedRequest;
};

export const useSearchCode = createHttpsCallableHook<
  SearchCodeRequest,
  SearchCodeResult
>("searchCode", middlewareOnCallSearchCodeRequest);
